export default __webpack_public_path__ + "static/RunRight6-855e1d23ae2e8103e96d370595b96760.mp3";